import getSubscriptionStatus from "@helpers/getSubscriptionStatus"
import {
  addTryFirstToLocalStorage,
  setLooksmaxxingCustomPurchasePixelEnabled,
  setOnboardingContext,
} from "@helpers/localStorage"
import { pathnameIsLooksmaxxingCustomPurchaseFunnel } from "@helpers/looksmaxxingCustomPurchaseFunnel"
import { getSession } from "@helpers/supabase"
import { LoaderFunctionArgs, redirect } from "react-router-dom"

export default async function looksmaxxingOnboardingLoader({
  request,
}: LoaderFunctionArgs) {
  setOnboardingContext("looksmaxxing")
  addTryFirstToLocalStorage("looksmaxxing")

  const pathname = new URL(request.url).pathname
  setLooksmaxxingCustomPurchasePixelEnabled(
    pathnameIsLooksmaxxingCustomPurchaseFunnel(pathname),
  )

  const signedInUsersRedirect = await redirectSignedInUsers()
  if (signedInUsersRedirect) return signedInUsersRedirect

  return null
}

async function redirectSignedInUsers() {
  const { data } = await getSession()

  const userId = data?.session?.user?.id

  if (userId) {
    const subscriptionStatus = await getSubscriptionStatus(userId)

    if (subscriptionStatus === "active") {
      return redirect("/account/subscription")
    } else {
      return redirect("/checkout/plans")
    }
  }
}
